/* CATEGORY LANDING ICON ROW SCROLLER */

/* TABLETOP CATEGORY COVER FLOW */
document.addEventListener('DOMContentLoaded', function() {
  var carousel = document.querySelector('[data-tabletop-carousel]');
  if (!carousel) return;

  var cards = Array.prototype.slice.call(carousel.querySelectorAll('[data-tabletop-card]'));
  var previous = carousel.querySelector('[data-tabletop-prev]');
  var next = carousel.querySelector('[data-tabletop-next]');
  var activeIndex = 0;
  var introTimer = null;
  var dragStartX = null;
  var dragLastX = null;
  var didDrag = false;
  var suppressClickUntil = 0;
  var productRequestController = null;
  var renderVersion = 0;
  var pointerDownCardIndex = -1;
  var dragStartTime = 0;
  var dragInitialIndex = 0;
  var dragAppliedSteps = 0;
  var lastPointerTime = 0;
  var releaseVelocity = 0;

  if (!cards.length) return;

  function wrappedDistance(index, center) {
    var distance = index - center;
    var half = cards.length / 2;
    if (distance > half) distance -= cards.length;
    if (distance < -half) distance += cards.length;
    return distance;
  }

  function render(index, immediate, refreshProducts) {
    renderVersion += 1;
    var currentRender = renderVersion;
    activeIndex = (index + cards.length) % cards.length;
    if (!immediate) carousel.classList.add('is-changing');

    cards.forEach(function(card, cardIndex) {
      var distance = wrappedDistance(cardIndex, activeIndex);
      var visible = Math.abs(distance) <= 2;
      card.classList.toggle('is-active', distance === 0);
      card.classList.toggle('is-visible', visible);
      card.setAttribute('aria-current', distance === 0 ? 'true' : 'false');
      card.setAttribute('aria-hidden', visible ? 'false' : 'true');
      card.setAttribute('tabindex', visible ? '0' : '-1');

      if (visible) {
        card.setAttribute('data-carousel-distance', distance);
      } else {
        card.removeAttribute('data-carousel-distance');
      }
    });

    window.setTimeout(function() {
      if (currentRender !== renderVersion) return;
      carousel.classList.remove('is-changing');
      if (refreshProducts) loadActiveProducts();
    }, immediate ? 0 : 145);
  }

  function loadActiveProducts() {
    var card = cards[activeIndex];
    var url = card.getAttribute('data-category-url');
    var section = document.querySelector('#CollectionSection');
    if (!url || !section) return;

    if (productRequestController) productRequestController.abort();
    productRequestController = new AbortController();
    var currentRequest = productRequestController;
    carousel.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin', signal: currentRequest.signal })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load category');
        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incomingGrid = doc.querySelector('[data-product-grid]');
        var currentGrid = section.querySelector('[data-product-grid]');
        var incomingCount = doc.querySelector('[data-collection-count]');
        var currentCount = section.querySelector('[data-collection-count]');
        var incomingPagination = doc.querySelector('[data-collection-pagination]');
        var currentPagination = section.querySelector('[data-collection-pagination]');

        if (!incomingGrid || !currentGrid) throw new Error('Category product grid was not found');
        currentGrid.outerHTML = incomingGrid.outerHTML;
        if (incomingCount && currentCount) currentCount.innerHTML = incomingCount.innerHTML;
        if (currentPagination) currentPagination.innerHTML = incomingPagination ? incomingPagination.innerHTML : '';
        section.setAttribute('data-source-collection-url', url);

        var selectedHandle = activeIndex === 0 ? '' : card.getAttribute('data-category-title').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        var visibleUrl = new URL(window.location.href);
        visibleUrl.searchParams.delete('filters');
        visibleUrl.searchParams.delete('page');
        if (selectedHandle) visibleUrl.searchParams.set('category', selectedHandle);
        else visibleUrl.searchParams.delete('category');
        window.history.pushState({ tabletopCategory: activeIndex }, '', visibleUrl.pathname + visibleUrl.search);
      })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        window.location.href = url;
      })
      .finally(function() {
        if (productRequestController === currentRequest) {
          carousel.classList.remove('is-loading');
          productRequestController = null;
        }
      });
  }

  carousel.addEventListener('click', function(event) {
    var card = event.target.closest('[data-tabletop-card]');
    if (!card || !carousel.contains(card)) return;
    event.preventDefault();
    if (Date.now() < suppressClickUntil) return;
    window.clearInterval(introTimer);
    var index = cards.indexOf(card);
    if (index !== -1 && index !== activeIndex) render(index, false, true);
    else if (index === activeIndex) loadActiveProducts();
  });

  if (previous) previous.addEventListener('click', function() { window.clearInterval(introTimer); render(activeIndex - 1, false, true); });
  if (next) next.addEventListener('click', function() { window.clearInterval(introTimer); render(activeIndex + 1, false, true); });

  carousel.addEventListener('keydown', function(event) {
    if (event.key === 'ArrowLeft') { event.preventDefault(); render(activeIndex - 1, false, true); }
    if (event.key === 'ArrowRight') { event.preventDefault(); render(activeIndex + 1, false, true); }
    if (event.key === 'Enter' && event.target === cards[activeIndex]) { event.preventDefault(); loadActiveProducts(); }
  });

  carousel.addEventListener('pointerdown', function(event) {
    if (event.button !== undefined && event.button !== 0) return;
    window.clearInterval(introTimer);
    dragStartX = event.clientX;
    dragLastX = event.clientX;
    dragStartTime = performance.now();
    lastPointerTime = dragStartTime;
    dragInitialIndex = activeIndex;
    dragAppliedSteps = 0;
    releaseVelocity = 0;
    var pressedCard = event.target.closest('[data-tabletop-card]');
    pointerDownCardIndex = pressedCard ? cards.indexOf(pressedCard) : -1;
    didDrag = false;
    carousel.classList.add('is-dragging');
    carousel.setPointerCapture(event.pointerId);
  });

  carousel.addEventListener('pointermove', function(event) {
    if (dragStartX === null) return;
    var totalDelta = event.clientX - dragStartX;
    var now = performance.now();
    var sampleTime = Math.max(1, now - lastPointerTime);
    releaseVelocity = (event.clientX - dragLastX) / sampleTime;
    dragLastX = event.clientX;
    lastPointerTime = now;
    if (Math.abs(totalDelta) > 12) didDrag = true;

    var desiredSteps = totalDelta < 0
      ? Math.floor(Math.abs(totalDelta) / 88)
      : -Math.floor(Math.abs(totalDelta) / 88);
    if (desiredSteps !== dragAppliedSteps) {
      dragAppliedSteps = desiredSteps;
      render(dragInitialIndex + dragAppliedSteps, false, false);
    }

    var remainder = totalDelta + (dragAppliedSteps * 88);
    var dampedX = remainder * .38;
    var arcY = -Math.min(6, (remainder * remainder) / 900);
    var tilt = Math.max(-2.2, Math.min(2.2, remainder / 35));
    var track = carousel.querySelector('[data-tabletop-track]');
    if (track) track.style.transform = 'translate3d(' + dampedX + 'px,' + arcY + 'px,0) rotateY(' + tilt + 'deg)';
  });

  function finishDrag(event) {
    if (dragStartX === null) return;
    var delta = event.clientX - dragStartX;
    var remainder = delta + (dragAppliedSteps * 88);
    var track = carousel.querySelector('[data-tabletop-track]');
    if (track) track.style.transform = '';
    if (Math.abs(delta) <= 14 && pointerDownCardIndex !== -1 && pointerDownCardIndex !== activeIndex) {
      render(pointerDownCardIndex, false, true);
      suppressClickUntil = Date.now() + 160;
    } else if (didDrag) {
      if (Math.abs(remainder) > 44 || (Math.abs(remainder) > 18 && Math.abs(releaseVelocity) > .45)) {
        render(activeIndex + (remainder < 0 ? 1 : -1), false, false);
      }
      render(activeIndex, false, true);
    }
    if (didDrag) suppressClickUntil = Date.now() + 160;
    dragStartX = null;
    dragLastX = null;
    pointerDownCardIndex = -1;
    carousel.classList.remove('is-dragging');
    window.setTimeout(function() { didDrag = false; }, 0);
  }

  carousel.addEventListener('pointerup', finishDrag);
  carousel.addEventListener('pointercancel', finishDrag);

  render(0, true);

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && cards.length > 1) {
    var introIndex = 0;
    introTimer = window.setInterval(function() {
      introIndex += 1;
      if (introIndex < cards.length) {
        render(introIndex, false);
      } else {
        window.clearInterval(introTimer);
        window.setTimeout(function() { render(0, false); }, 90);
      }
    }, 90);
  }
});

document.addEventListener('DOMContentLoaded', function() {

  var rows = document.querySelectorAll('[data-category-row]');

  rows.forEach(function(row) {

    var track = row.querySelector('[data-category-track]');
    var leftArrow = row.querySelector('.category-icon-arrow--left');
    var rightArrow = row.querySelector('.category-icon-arrow--right');

    if (!track || !leftArrow || !rightArrow) return;

    function updateArrows() {

      var maxScroll = track.scrollWidth - track.clientWidth;

      if (track.scrollLeft <= 5) {
        leftArrow.classList.add('hidden');
      } else {
        leftArrow.classList.remove('hidden');
      }

      if (track.scrollLeft >= maxScroll - 5) {
        rightArrow.classList.add('hidden');
      } else {
        rightArrow.classList.remove('hidden');
      }
    }

    function getScrollAmount() {

      var card = track.querySelector('.category-icon-card');

      if (!card) return 300;

      var styles = window.getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap || 24, 10);

      return card.offsetWidth * 4 + gap * 4;
    }

    leftArrow.addEventListener('click', function() {

      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });

    });

    rightArrow.addEventListener('click', function() {

      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });

    });

    track.addEventListener('scroll', updateArrows);

    window.addEventListener('resize', updateArrows);

    updateArrows();

  });

});


/* BROWSE ASSISTANT ACTIVE STATE */
/*
document.addEventListener('click', function(event) {
  var clicked = event.target.closest('.category-browse-link');

  if (!clicked) return;

  var line = clicked.closest('.category-browse-line');

  if (!line) return;

  line.querySelectorAll('.category-browse-link').forEach(function(link) {
    link.classList.remove('is-active');
  });

  clicked.classList.add('is-active');
});



document.addEventListener('click', function(event) {
  var clicked = event.target.closest('.category-browse-link');

  if (!clicked) return;

  var assistant = clicked.closest('.category-browse-assistant');

  if (!assistant) return;

  var contextType = clicked.getAttribute('data-context-type');
  var isAlreadyActive = clicked.classList.contains('is-active');

  if (contextType) {
    assistant.querySelectorAll('.category-browse-link[data-context-type="' + contextType + '"]').forEach(function(link) {
      link.classList.remove('is-active');
    });
  } else {
    assistant.querySelectorAll('.category-browse-link').forEach(function(link) {
      link.classList.remove('is-active');
    });
  }

  if (!isAlreadyActive) {
    clicked.classList.add('is-active');
  }
});
*/



/* Collection nav arrows */
document.addEventListener('DOMContentLoaded', function() {
  var wraps = document.querySelectorAll('[data-collection-nav-wrap]');

  wraps.forEach(function(wrap) {
    var nav = wrap.querySelector('[data-collection-nav]');
    var left = wrap.querySelector('[data-collection-nav-left]');
    var right = wrap.querySelector('[data-collection-nav-right]');

    if (!nav || !left || !right) return;

    function updateArrows() {
      var maxScroll = nav.scrollWidth - nav.clientWidth;
      var currentScroll = nav.scrollLeft;

      left.classList.toggle('is-hidden', currentScroll <= 2);
      right.classList.toggle('is-hidden', currentScroll >= maxScroll - 2 || maxScroll <= 2);
    }

    left.addEventListener('click', function() {
      nav.scrollBy({
        left: -nav.clientWidth * 0.75,
        behavior: 'smooth'
      });
    });

    right.addEventListener('click', function() {
      nav.scrollBy({
        left: nav.clientWidth * 0.75,
        behavior: 'smooth'
      });
    });

    nav.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});


/* AJAX-safe collapsible sidebar filter groups */
document.addEventListener('click', function(event) {
  var title = event.target.closest('.custom-collection-sidebar .filter-menu-title');
  if (!title) return;

  event.preventDefault();
  event.stopPropagation();

  var group = title.closest('.filter-menu-group');
  if (!group) return;

  var list = group.querySelector('.filter-menu-list');
  var isCollapsed = group.classList.contains('is-collapsed');

  if (isCollapsed) {
    group.classList.remove('is-collapsed');
    title.setAttribute('aria-expanded', 'true');

    if (list) {
      list.style.maxHeight = list.scrollHeight + 'px';

      window.setTimeout(function() {
        list.style.maxHeight = '';
      }, 220);
    }
  } else {
    if (list) {
      list.style.maxHeight = list.scrollHeight + 'px';

      window.requestAnimationFrame(function() {
        group.classList.add('is-collapsed');
        title.setAttribute('aria-expanded', 'false');
        list.style.maxHeight = '0px';
      });
    } else {
      group.classList.add('is-collapsed');
      title.setAttribute('aria-expanded', 'false');
    }
  }
});

/* Color swatch filter arrow controls */
document.addEventListener('click', function(event) {
  var leftButton = event.target.closest('[data-color-filter-left]');
  var rightButton = event.target.closest('[data-color-filter-right]');

  if (!leftButton && !rightButton) return;

  event.preventDefault();

  var wrap = event.target.closest('[data-color-filter-wrap]');
  if (!wrap) return;

  var list = wrap.querySelector('[data-color-filter-list]');
  if (!list) return;

  var firstItem = list.querySelector('.color-filter-item');
  var itemWidth = firstItem ? firstItem.offsetWidth : 22;

  var listStyle = window.getComputedStyle(list);
  var gap = parseFloat(listStyle.columnGap || listStyle.gap || 9) || 9;

  var scrollAmount = (itemWidth + gap) * 3;

  list.scrollBy({
    left: leftButton ? -scrollAmount : scrollAmount,
    behavior: 'smooth'
  });
});

function updateColorFilterArrows() {
  document.querySelectorAll('[data-color-filter-wrap]').forEach(function(wrap) {
    var list = wrap.querySelector('[data-color-filter-list]');
    var leftButton = wrap.querySelector('[data-color-filter-left]');
    var rightButton = wrap.querySelector('[data-color-filter-right]');
    var scrollContainer = wrap.querySelector('.color-filter-scroll');

    if (!list || !leftButton || !rightButton || !scrollContainer) return;

    var maxScroll = list.scrollWidth - list.clientWidth;
    var currentScroll = Math.round(list.scrollLeft);

    leftButton.classList.toggle('is-hidden', currentScroll <= 1);
    rightButton.classList.toggle('is-hidden', currentScroll >= maxScroll - 1 || maxScroll <= 1);

    scrollContainer.classList.remove('has-left-overflow', 'at-end');

    if (currentScroll > 1) {
      scrollContainer.classList.add('has-left-overflow');
    }

    if (currentScroll >= maxScroll - 1 && maxScroll > 1) {
      scrollContainer.classList.add('at-end');
    }
  });
}

document.addEventListener('scroll', function(event) {
  if (
    event.target &&
    event.target.matches &&
    event.target.matches('[data-color-filter-list]')
  ) {
    updateColorFilterArrows();
  }
}, true);

document.addEventListener('click', function(event) {
  if (
    event.target.closest('[data-color-filter-left]') ||
    event.target.closest('[data-color-filter-right]')
  ) {
    window.setTimeout(updateColorFilterArrows, 260);
  }
});

window.addEventListener('resize', updateColorFilterArrows);
document.addEventListener('DOMContentLoaded', updateColorFilterArrows);


/*adds name of color upon hover under icon row of filter sidebar*/ 
document.addEventListener('mouseover', function(event) {
  var label = event.target.closest('.color-filter-label');
  if (!label) return;

  var group = label.closest('.filter-menu-group--color');
  if (!group) return;

  var nameEl = group.querySelector('[data-color-filter-hover-name]');
  var name = label.getAttribute('title');

  if (!nameEl || !name) return;

  nameEl.textContent = name;
  group.classList.add('is-showing-color-name');
});

document.addEventListener('mouseout', function(event) {
  var label = event.target.closest('.color-filter-label');
  if (!label) return;

  var group = label.closest('.filter-menu-group--color');
  if (!group) return;

  var related = event.relatedTarget;

  if (related && label.contains(related)) return;

  var nameEl = group.querySelector('[data-color-filter-hover-name]');
  if (nameEl) nameEl.textContent = '';

  group.classList.remove('is-showing-color-name');
});





/*expand 'more' on page.category-landing.liquid for page description*/ 
/* Inline "More" for page.category-landing.liquid description */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.category-landing-page-description-wrap').forEach(function(wrap) {

    var description = wrap.querySelector('[data-category-description]');
    var button = wrap.querySelector('[data-category-description-toggle]');
    var header = wrap.closest('.category-landing-page-header');

    if (!description || !button || !header) return;

    var originalHTML = description.innerHTML;
    var originalText = description.textContent.trim();

    var maxLength = parseInt(wrap.getAttribute('data-description-length'), 10) || 200;

    if (originalText.length <= maxLength) {
      button.style.display = 'none';
      return;
    }

    var truncated = originalText.substring(0, maxLength);
    var lastSpace = truncated.lastIndexOf(' ');

    if (lastSpace > 0) {
      truncated = truncated.substring(0, lastSpace);
    }

    function renderCollapsed() {
      description.innerHTML = '';

      var p = document.createElement('p');
      p.textContent = truncated + '… ';

      button.textContent = 'View More';
      p.appendChild(button);

      description.appendChild(p);
    }

    function renderExpanded() {
      description.innerHTML = originalHTML;

      var paragraphs = description.querySelectorAll('p');
      var target = paragraphs.length ? paragraphs[paragraphs.length - 1] : description;

      target.appendChild(document.createTextNode(' '));

      button.textContent = 'View Less';
      target.appendChild(button);
    }

    renderCollapsed();

    button.addEventListener('click', function(e) {
      e.preventDefault();

      if (!wrap.classList.contains('expanded')) {
        wrap.classList.add('expanded');
        header.classList.add('expanded');
        renderExpanded();
      } else {
        wrap.classList.remove('expanded');
        header.classList.remove('expanded');
        renderCollapsed();
      }
    });

  });

});
